import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {LocalDataSource} from '../../../ng2-smart-table/lib/data-source/local/local.data-source';
import { ModalController } from '@ionic/angular';
import { EditTextComponent } from '../../modals/edit-text/edit-text.component';
import { Nl2BrPipe } from 'nl2br-pipe';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the HistoryComponent component.
 */
@Component({
  selector: 'history',
  templateUrl: 'history.html',
  styleUrls: ['./history.scss'],
  providers: [DatePipe, Nl2BrPipe]
})
export class HistoryComponent implements OnInit {

  data: LocalDataSource = new LocalDataSource();

  private _user:any;
  settings: { columns: { dateTime: { title: string; valuePrepareFunction: (date: any) => string; sort: boolean; sortDirection: string; }; code: { title: string; }; desc: { title: string; valuePrepareFunction: (text: any) => string; type: string; }; editorPerson: { title: string; }; }; actions: any; filter: any; pager: { display: boolean; perPage: number; }; hideSubHeader: boolean; noDataMessage: string; };

  constructor(private modalCtrl:ModalController, private datePipe: DatePipe, 
    private nl2brPipe:Nl2BrPipe, private translate:TranslateService) {
    this._user = JSON.parse(localStorage.getItem('hnr-token'));
  }

  @Output() updateHistoryDesc = new EventEmitter<string>();

  @Input() set historyData(data: Array<any>) {
    data.map((d, i) => {
      d.index = i;
    })
    this.data.load(data);
  }

  async ngOnInit() {

    let translateData = await firstValueFrom(this.translate.get(['Date', 'AlertCode', 'Description', 'Editor', 'Message.NoHistoryData']));
    translateData = Object.values(translateData);

    this.settings = {
      columns: {
        dateTime: {
          title: translateData[0],
          valuePrepareFunction: (date) => {
            return new DatePipe('de').transform(date, 'dd.MM.yyyy HH:mm:ss');
          },
          sort: true,
          sortDirection: 'desc'
        },
        code: {
          title: translateData[1]
        },
        desc: {
          title: translateData[2],
          valuePrepareFunction: (text) => {
            return this.nl2brPipe.transform(text);
          },
          type:'html'
        },
        editorPerson: {
          title: translateData[3]
        }
      },
      actions: null,
      filter: null,
      pager: {
        display: true,
        perPage: 5
      },
      hideSubHeader: false,
      noDataMessage: translateData[4]
    };
  }

  async rowSelect(rowData) {
    const saveDesc = rowData.data.desc;

    const modal = await this.modalCtrl.create({
      component: EditTextComponent,
      componentProps: {
        comment: rowData.data.desc
      }
    });

    await modal.present();
    const {data} = await modal.onDidDismiss();

    if(data) {
      rowData.data.desc = saveDesc+'\n\n'+ this.datePipe.transform(new Date(), 'dd.MM.yyyy HH:mm:ss')+" : "+this._user.profile.firstname + ' ' + this._user.profile.lastname+'\n'+data;
      this.updateHistoryDesc.emit(rowData.data);
    }
  }

}
